// permissionSubset.js
//
// JS mirror of app/models/concerns/permission_subset.rb.
// Used by the permission UI to disable / strip permissions the current
// operator cannot grant, so the user sees the limit before submitting.
//
// 不再有 whitelist 概念 — 白名單已被 yml 內的 `open` 取代。

function expand(permission, { resources, resourceActions, allActions }) {
  const [resource, action] = (permission || '').split(':');
  if (!resource || !action) return [];

  const targetResources = resource === '*' ? resources : [resource];
  const actionsFor = (r) => {
    if (action !== '*') return [action];
    return resourceActions[r] || allActions;
  };

  const pairs = [];
  targetResources.forEach((r) => {
    actionsFor(r).forEach((a) => pairs.push([r, a]));
  });
  return pairs;
}

function granterHas(granterPerms, resource, action) {
  return granterPerms.some(
    (g) =>
      g === '*:*' ||
      g === `${resource}:*` ||
      g === `*:${action}` ||
      g === `${resource}:${action}`
  );
}

/**
 * Is candidate permission implied by granterPerms?
 * config = { resources, resourceActions, allActions } from the generated manifest.
 * Fails closed on malformed candidates (returns false).
 */
export function implies(granterPerms, candidate, config) {
  const pairs = expand(candidate, config);
  if (pairs.length === 0) return false;
  return pairs.every(([r, a]) => granterHas(granterPerms, r, a));
}

/**
 * canGrant: true if granter can grant this single permission.
 * config = { resources, resourceActions, allActions }.
 */
export function canGrant(granterPerms, candidate, config) {
  return implies(granterPerms, candidate, config);
}

/**
 * Returns the subset of candidates the granter cannot grant.
 */
export function ungrantable(candidates, granterPerms, config) {
  return candidates.filter((c) => !canGrant(granterPerms, c, config));
}

/**
 * Filters the candidate list, dropping ungrantable perms. Returns { kept, dropped }.
 */
export function filterGrantable(candidates, granterPerms, config) {
  const kept = [];
  const dropped = [];
  candidates.forEach((c) => {
    if (canGrant(granterPerms, c, config)) {
      kept.push(c);
    } else {
      dropped.push(c);
    }
  });
  return { kept, dropped };
}
